import { render, staticRenderFns } from "./PurchaseCancelNew.vue?vue&type=template&id=bfdb2bf0&scoped=true"
import script from "./PurchaseCancelNew.vue?vue&type=script&lang=js"
export * from "./PurchaseCancelNew.vue?vue&type=script&lang=js"
import style0 from "./PurchaseCancelNew.vue?vue&type=style&index=0&id=bfdb2bf0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdb2bf0",
  null
  
)

export default component.exports